var map = {
	"./cs.json": 292,
	"./de.json": 229,
	"./en.json": 473,
	"./es.json": 18,
	"./fa.json": 315,
	"./fr.json": 946,
	"./it.json": 355,
	"./ja.json": 39,
	"./nl.json": 340,
	"./no.json": 137,
	"./pl.json": 966,
	"./pt.json": 750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 761;